import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { createLabelGroupProperty } from '@/routes/projectStages/issues/lib/hooks/useCreateLabelGroupsProperties.tsx'
import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import { createStatusGroupProperty } from '@/routes/projectStages/issues/lib/issuesHelpers/createStatusGroupProperty.tsx'
import getAvailableFilters from '@/routes/projectStages/issues/lib/issuesHelpers/getAvailableFilters.tsx'
import { useCallback, useEffect } from 'react'
import {
  IssueTypePropertiesT,
  usePropertiesByIssueTypeStore,
} from '@/routes/projectStages/issues/lib/stores/usePropertiesByIssueTypeStore.tsx'
import createSeparator from '@/components/common/propertyPopoverOverlay/createSeparator.tsx'
/*  create filters properties initially after login or when currStageIssueTypes changes and
 store them in zustand*/
export default function useCreatePropertiesByIssueType(
  currStageIssueTypes: IssueTypeT[] | null | undefined,
  stageId: string | number | null | undefined,

  selectAllProperty: PopoverProperty,
  creatorsProperty: PopoverProperty,
  recipientsProperty: PopoverProperty,
  clearFiltersProperty: PopoverProperty,
  locationProperty: PopoverProperty,
) {
  const setProperties = usePropertiesByIssueTypeStore(state => state.setProperties)

  const createProperties = useCallback(() => {
    if (!currStageIssueTypes) return []

    const propertiesByIssueType = currStageIssueTypes.map((issueT: IssueTypeT) => {
      const { statuses, statusGroupProperty } = createStatusGroupProperty(issueT)

      if (issueT.id === 9) {
        // console.log(issueT.statusGroup)
        // console.log({ statusGroupProperty })
        // console.log({ statuses })
      }

      const labelGroupsProperties: PopoverProperty[] =
        issueT?.labelGroups?.map(labelGroup => {
          const labelGroupProp = createLabelGroupProperty(labelGroup)
          return labelGroupProp
        }) ?? []

      const labelGroupsPropertiesWithSelectAll: PopoverProperty[] =
        issueT?.labelGroups?.map(labelGroup => {
          const labelGroupProp = createLabelGroupProperty(labelGroup)
          if (labelGroupProp.children) {
            labelGroupProp.children = [
              selectAllProperty,
              createSeparator(),
              ...labelGroupProp.children,
            ]
          }
          return labelGroupProp
        }) ?? []

      const { allFiltersProperties } = getAvailableFilters(
        recipientsProperty,
        creatorsProperty,
        labelGroupsPropertiesWithSelectAll,
        issueT,
        statusGroupProperty,
        clearFiltersProperty,
        locationProperty,
      )

      statusGroupProperty.children = [
        selectAllProperty,
        createSeparator(),
        ...(statusGroupProperty.children ?? []),
      ]

      const issueTypeProperties: IssueTypePropertiesT = {
        issueTypeId: issueT.id,
        statuses: statuses,
        allFiltersProperties: allFiltersProperties,
        labelGroupsProperties: labelGroupsProperties,
        statusGroupProperty: statusGroupProperty,
      }

      return issueTypeProperties
    })

    return propertiesByIssueType
  }, [
    clearFiltersProperty,
    creatorsProperty,
    currStageIssueTypes,
    locationProperty,
    recipientsProperty,
    selectAllProperty,
  ])

  useEffect(() => {
    if (!stageId) return
    const propertiesByIssueType = createProperties()
    // console.log(propertiesByIssueType, `by issue t`)

    // console.log(
    //   ` setting properties in root this should happens only once after login or projectStage change ❌❌❌`,
    // )
    setProperties(propertiesByIssueType)
  }, [createProperties, setProperties, stageId])
}
